import React, {FC, ReactNode} from "react"

import {Body, H2, H4} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"

interface Props {
  boldValue: string
  text: string
  children?: ReactNode
  color?: string
  small?: boolean
}

const BoldNumberSmallText: FC<Props> = ({boldValue, text, children, color, small}) => {
  const Heading = small ? H4 : H2
  return (
    <Flex alignItems="baseline">
      <Heading color={color}>{boldValue}</Heading>
      <Body paddingTop={1} color={color} marginLeft small>
        <FormattedMessage id={text} />
      </Body>
      {children}
    </Flex>
  )
}

export default BoldNumberSmallText
